import { z } from "zod";
import { GRADE, MODULE, SUB_MODULE } from "../consts";

export const schema = z.object({
  [GRADE]: z.string().min(1, "This field is required"),
  [MODULE]: z.string().min(1, "This field is required"),
  [SUB_MODULE]: z.string().min(1, "This field is required"),
});

export type formValues = z.infer<typeof schema>;
